export const PROD_AFFILIATE_COOKIE = 'prod_affiliate';
export const DEV_AFFILIATE_COOKIE = 'dev_affiliate';